const subscriptionUrl = {
  subscription: '/settings/subscription',
  cancel: () => `${subscriptionUrl.subscription}/cancel`,
  missing: () => `${subscriptionUrl.cancel()}/missing`,
  reason: () => `${subscriptionUrl.cancel()}/reason`,
  details: () => `${subscriptionUrl.cancel()}/details`,
  otherTool: () => `${subscriptionUrl.cancel()}/other-tool`,
  recap: () => `${subscriptionUrl.cancel()}/recap`,
};

export default subscriptionUrl;
